/* src/app/location/map-location/map-location.component.scss */
.flex-container {
  height: calc(100vh - 63px);
  overflow-y: auto;
}
h1 {
  font-size: 20px;
  margin-bottom: 31px;
  margin-top: 0px;
  font-weight: 600;
  line-height: 30px;
}
.main-content {
  width: 100%;
  height: 450px;
  overflow-y: hidden;
}
.main-content .input-container {
  display: flex;
  align-items: center;
  gap: 1rem;
  position: relative;
}
.main-content .input-container i {
  margin-left: 10px;
  font-size: 14px;
}
.main-content .input-container ::ng-deep #search-box {
  width: 350px !important;
  height: 44px;
  border-radius: 8px;
  padding: 8px 48px;
  border: none;
  border: 1px solid #d0d5dd;
}
.main-content .input-container ::ng-deep #search-box:hover {
  border-color: #ff9f2a;
}
.main-content .input-container ::ng-deep #search-box:focus {
  border-color: #ff9f2a;
  outline: none;
}
.main-content .address-map-container {
  border: 1px solid #e4e7ec;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 32px;
  margin-right: 20px;
}
.main-content .address-map-container h3 {
  font-size: 14px;
  color: #98A2B3;
  margin: 0 0 8px 0;
}
.main-content .address-map-container p {
  font-size: 16px;
  margin: 0 0 16px 0;
  font-weight: bold;
  font-style: normal;
}
.main-content .address-map-container .map {
  width: 100%;
  height: 400px;
  margin: 0;
  border: 1px solid #e4e7ec;
}
.main-content .icon {
  font-size: 24px;
  color: #ff9f2a;
  margin: 0px 18px 0 20px;
}
::ng-deep .pac-container {
  background: #ffffff !important;
  border-radius: 12px !important;
  border: none !important;
  padding: 10px 15px !important;
  z-index: 1000 !important;
  margin-top: 8px !important;
}
::ng-deep .pac-item {
  font-size: 12px;
  padding: 14px 0px !important;
  border-top: none !important;
  border-bottom: 1px solid #e0e0e0 !important;
  align-items: center !important;
}
::ng-deep .pac-item:last-child {
  border-bottom: none !important;
}
::ng-deep .pac-icon {
  width: 20px !important;
  height: 20px !important;
  margin-right: 10px !important;
  filter: none;
  color: #000;
  display: none !important;
  align-items: center !important;
}
::ng-deep .pac-container:after {
  display: none !important;
}
::ng-deep .pac-item::before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  background-image: url(https://cdn.jsdelivr.net/npm/bootstrap-icons/icons/geo-alt.svg);
  background-size: contain;
  background-repeat: no-repeat;
  margin-right: 12px;
  vertical-align: middle;
}
::ng-deep .p-inputtext {
  height: 44px;
}
::ng-deep .p-inputtext:focus {
  outline: none !important;
  border-color: orange !important;
  background-color: white !important;
}
::ng-deep .p-inputtext:hover {
  outline: none !important;
  border-color: orange !important;
  background-color: white !important;
}
/*# sourceMappingURL=map-location.component-CS6XYQ4U.css.map */
